import { Box, Typography } from '@material-ui/core'
import { Circle } from '@material-ui/icons'
import React from 'react'
import { Colors } from 'src/components/atoms'
import { useGlobalStyles } from 'src/styles/theme'

export interface AnnouncementTitleCellProps {
  value: string
  isRead: boolean
}
export const AnnouncementTitleCell = ({ value, isRead }: AnnouncementTitleCellProps) => {
  const globalClasses = useGlobalStyles()
  return (
    <Box
      width={1}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}
    >
      {!isRead ? (
        <Circle style={{ color: Colors.accent.keyRed.default, fontSize: '10px' }} />
      ) : (
        <Box style={{ width: '10px' }} />
      )}
      <Box whiteSpace="pre-wrap" className={globalClasses.lineclamp1}>
        <Typography style={{ fontSize: '14px', fontWeight: 'bold' }}>{value}</Typography>
      </Box>
    </Box>
  )
}
